import {fork} from 'redux-saga/effects';

import {error_saga} from "./features/errors/error_saga";
import {reg_saga} from "./features/registration/reg_saga";
import {session_saga} from "./session_state/session_sagas";


function* root() {
    yield fork(error_saga);
    yield fork(reg_saga);
    yield fork(session_saga);

}

export default root;
